<article class="supports-details-container">
  <section class="side-menu">
    <app-settings-side-menu></app-settings-side-menu>
  </section>
  <section class="wrapper">
    <router-outlet></router-outlet>
  </section>
</article>
